export default __webpack_public_path__ + "fonts/97dc58c8a789b5c95882a73ff8c88ca2.ttf";